// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popover-inner{background-color:#fff!important;box-shadow:0 2px 24px 0 rgba(0,0,0,.17)}.vc-chrome{box-shadow:none!important}.vc-chrome-body{padding-bottom:0!important}", ""]);
// Exports
module.exports = exports;
